import { ACCESS_TOKEN_NAME } from 'constants/access-token';
import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  withCredentials: true,
});

if (typeof window !== 'undefined') {
  const accessToken = window?.localStorage.getItem(ACCESS_TOKEN_NAME);
  if (accessToken) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    api.defaults.headers.common.Authorization = `Bearer: ${accessToken}`;
  }
}
